import { render, staticRenderFns } from "./UdSelectMultiple.vue?vue&type=template&id=2070fdd8&scoped=true&"
import script from "./UdSelectMultiple.vue?vue&type=script&lang=js&"
export * from "./UdSelectMultiple.vue?vue&type=script&lang=js&"
import style0 from "./UdSelectMultiple.vue?vue&type=style&index=0&id=2070fdd8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2070fdd8",
  null
  
)

export default component.exports